import { TaxRole } from './tax-role.enum';

export class TaxToken {
    role = TaxRole.Owner;
    email = '';
    expiry = new Date();
    lastUpdated = new Date();
    valid = true;

    deserialize(data: any) {
        const now = new Date().toISOString();
        this.role = data.role ?? TaxRole.Owner;
        this.email = data.email ?? '';
        this.expiry = data.expiry !== null ? new Date(data.expiry) : new Date(now);
        this.lastUpdated = data.last_updated !== null ? new Date(data.last_updated) : new Date(now);
        this.valid = this.expiry > new Date(now);
        return this;
    }

    clone(): TaxToken {
        return new TaxToken().deserialize({
            role: this.role,
            email: this.email,
            'last_updated': this.lastUpdated.toISOString(),
            expiry: this.expiry.toISOString(),
        });
    }
}
